import { InvoiceRow } from '../components/Invoice/types'
import { PrintTemplateDetail } from '../components/OCRImport/types'

export function sumOfTotalCost(array: InvoiceRow[] | PrintTemplateDetail[]) {
  let sum = 0
  array.forEach((obj) => {
    if (obj.total_price) {
      sum += obj.total_price
    }
  })
  const options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 10,
  }

  return sum.toLocaleString(undefined, options)
}
